/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('PublicFolderLinkShareModalController', [
        '$scope',
        '$modalInstance',
        'publicFolderLink',
        function (
            $scope,
            $modalInstance,
            publicFolderLink
        ) {
            $scope.modal = $modalInstance.options;
            $scope.publicFolderLink = publicFolderLink;
            $scope.close = $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
    ]);
